import Alignment from '../_alignment/alignment';

const lastPost = {
    section: '.block-last-posts',
    element: '.last-post__title',
    number: 3,
};

const evenImgLinks = {
    section: '.block-content-links-images',
    element: '.image-link',
    number: 3,
};

const blogPostsTitles = {
    section: '.posts-main-wrapper',
    element: '.post__title',
    number: 3,
};

const evenPost = new Alignment(lastPost);
const evenLinks = new Alignment(evenImgLinks);
const blogPost = new Alignment(blogPostsTitles);

export { evenPost, evenLinks, blogPost };
